import React, { createContext, useContext, useState, useEffect } from 'react';
import DakhlaButterflyLoader from '../components/common/DakhlaButterflyLoader';

const AuthContext = createContext();

export const useAuth = () => {
 const context = useContext(AuthContext);
 if (!context) {
 throw new Error('useAuth must be used within an AuthProvider');
 }
 return context;
};

export const AuthProvider = ({ children }) => {
 const [user, setUser] = useState(null);
 const [token, setToken] = useState(null);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
 // Check if user is logged in on app start
 const storedToken = localStorage.getItem('token');
 const storedUser = localStorage.getItem('user');
 
 if (storedToken && storedUser) {
 setToken(storedToken);
 setUser(JSON.parse(storedUser));
 }
 setLoading(false);
 }, []);

 const login = (userData, userToken) => {
 setUser(userData);
 setToken(userToken);
 localStorage.setItem('token', userToken);
 localStorage.setItem('user', JSON.stringify(userData));
 };

 const logout = () => {
 setUser(null);
 setToken(null);
 localStorage.removeItem('token');
 localStorage.removeItem('user');
 };

 const updateUser = (updatedFields) => {
 setUser(prev => {
 if (!prev) return null;
 const updated = { ...prev, ...updatedFields };
 localStorage.setItem('user', JSON.stringify(updated));
 return updated;
 });
 };

 const value = {
 user,
 token,
 login,
 logout,
 updateUser,
 isAuthenticated: !!user,
 isStudent: user?.role === 'student',
 isUniversity: user?.role === 'university'
 };

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <DakhlaButterflyLoader text="Initializing..." />
      </div>
    );
  }

 return (
 <AuthContext.Provider value={value}>
 {children}
 </AuthContext.Provider>
 );
};